import React, { Component } from 'react';
import './style/Portabilidade.css';
import './style/normalize.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import NumberFormat_ from 'react-number-format';

class Portabilidade extends Component {

    constructor(props){
        super(props);
        this.state= {
            cpf:"",
            name:"",
            oldNumber:"",
            newNumber:"",
            operadora:"",
            opacity1: false,
            token: ""
        }
    }

    lettersOnly = (e) => {

        let keyCode = e.keyCode || e.which;
 
        //console.log(keyCode);
        //Regex for Valid Characters i.e. Alphabets.
        let regex = /^[a-zA-Z]+$/;
 
        //Validate TextBox value against the Regex.
        let isValid = regex.test(String.fromCharCode(keyCode));

        console.log(!isValid);
        
        if ((!isValid && keyCode !== 8) || (keyCode >= 96 && keyCode <= 111)) {
            e.preventDefault();
            return false;
        }
 
        return isValid;
    }

    validCpf = (strCPF) => {
        let Soma;
        let Resto;
        Soma = 0;
      if (strCPF == "00000000000") return false;
         
      for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;
       
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;
       
      Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
       
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
        return true;
    }

    handleChange = (event) => {
        var re = /^[A-Za-z ]+$/;
        if(re.test(event.target.value) || !event.target.value)
            this.setState({name: event.target.value})

        // this.setState({name: event.target.value})
    }

    handleChangeSelect = (event) => {
        this.setState({operadora: event.target.value})
    }

    countDay = (quant) => {
        var dt = new Date(); dt.setDate(dt.getDate() + quant);
        var mes = dt.getMonth();
        var ano = dt.getFullYear();
        var dia = dt.getDate();

        mes = mes <= 9 ? 0+mes.toString() : mes;
        console.log( ano + "-" +mes + "-" + dia);
        return ano + "-" +mes + "-" + dia;
    }

    executeFunction = () => {

        if(this.state.newNumber === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite o novo número!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }

        if(this.state.oldNumber === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite o número anterior!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }

        

        if(this.state.newNumber === this.state.oldNumber){

            Swal.fire({
                title: 'Erro!',
                text: "Número operadora antiga e número novo não podem ser iguais!",
                type: 'error',
                icon: 'error'
            });

            this.setState({loading: false}); 
            return false;
        }

        if(this.state.newNumber.substr(0, 2) !== this.state.oldNumber.substr(0, 2)){
            Swal.fire({
                title: 'Erro!',
                text: "DDD operadora antiga e DDD operadora nova não podem ser diferentes!",
                type: 'error',
                icon: 'error'
            });

            this.setState({loading: false}); 
            return false;

        }

        
        if(!this.validCpf(this.state.cpf)){
            Swal.fire({
                title: 'Erro!',
                text: "CPF inválido!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }

        

        if(this.state.name === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite seu nome!",
                type: 'error',
                icon: 'error'
            });

            this.setState({loading: false}); 
            return false;
        }

        if(this.state.operadora === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite selecione a operadora!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }

        this.setState({opacity1: true}); 

        axios.post(`https://www.pagtel.com.br/AlgarCasca360/auth/v1/validatePhone`, {
            Network:"Algar",
            MSISDN: "55"+this.state.newNumber,
            Version: "0.1",
            UniqueID: "xxxxx",
            OS: "Navegador",
            SystemVersion:"0.1",
            Model: "PC",
            Source: "site"
        })
        .then(res => {
            if((res.data.code === "00")||(res.data.code === "04")){
                this.setState({token: res.data.accessToken});     
                this.goPortabilidade();            
            }
            else {
                Swal.fire(
                'Erro!',
                res.data.msg,
                'error'
                )
                this.setState({opacity1: false}); 
            }
        })
        .catch(res => {
            Swal.fire(
                'Erro!',
                "Não foi possível conectar com o servidor!",
                'error'
            )
            this.setState({opacity1: false}); 
        })

    }

    goPortabilidade = () => {

        if(this.state.name === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite seu nome!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }
        if(this.state.cpf === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite seu CPF!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }

        if(!this.validCpf(this.state.cpf)){
            Swal.fire({
                title: 'Erro!',
                text: "CPF inválido!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }

        if(this.state.oldNumber === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite o número anterior!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }

        if(this.state.newNumber === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite o novo número!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }

        if(this.state.operadora === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite selecione a operadora!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }

        this.setState({opacity1: true}); 

        if(this.state.name === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite seu nome!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }
        if(this.state.cpf === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite seu CPF!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }

        if(this.state.newNumber === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite o novo número!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }

        if(this.state.oldNumber === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite o número anterior!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }

        

        if(this.state.operadora === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite selecione a operadora!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
            return;
        }


    
        axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/submitPortin`, {
            transactionId: new Date().getTime(),
            MSISDN: this.state.newNumber,
            PMSISDN: this.state.oldNumber,
            CPF: this.state.cpf,
            operatorCode: this.state.operadora,
            portinDate: this.countDay(2),
            name: this.state.name
        }, { headers: {"Authorization": "Bearer " + this.state.token } })
        .then(res => {
            if(res.data.code == "P0001"){
                Swal.fire({
                    title: 'sucesso!',
                    text: res.data.description,
                    type: 'success'
                })
                this.setState({opacity1: false}); 
            }
            else {
                Swal.fire({
                    title: 'Erro!',
                    text: res.data.description,
                    type: 'error'
                })
                this.setState({opacity1: false}); 
            }

        })
        .catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao tentar efetuar a probabilidade!",
                type: 'error'
            })
            this.setState({opacity1: false}); 
        })
        

    }

    render() {
        const opacity1 = this.state.opacity1 ? 'opacity' : '';
        return (
            <div className="content-portabilidade">
                <div className="shell-portabilidade">
                    <h3>PORTABILIDADE</h3>
                    <p>A portabilidade permite que o número que você usava na outra operadora continue o mesmo com seu novo Chip.</p>
                    <p>Veja como é fácil e rápido.</p>

                    <h4>Para saber seu número de celular</h4>
                    <br/>
                    <ul>
                        <li>1. Insira seu novo chip no seu aparelho celular.</li>
                        <li>2. Caso ainda não tenha ativado seu chip, ligue para *288 e cadastre seu CPF.</li>
                        <li>3. Você receberá um SMS informando seu número. Se precisar disque *221# para saber seu número e anote.</li>
                    </ul>
                    <br/>
                    <h4>Para realizar a portabilidade</h4>
                    <br/>
                    <ul>
                        <li>1. Agora é só inserir o chip da sua operadora antiga no seu celular e seguir o passo a passo.</li>
                        <li>2. Será enviado um SMS para seu número da sua operadora antiga com um link.</li>
                        <li>3. Você deve clicar no link e aguardar até que apareça o botão CONFIRMAR.</li>
                        <li>4. Clique no botão para CONFIRMAR sua solicitação de portabilidade.</li>
                        <li>5. Agora é só aguardar. Caso todas as informações estejam corretas você receberá um SMS informando: Portabilidade concluída com sucesso! </li>
                    </ul>
                    <br/>
                    <h4>Condições para realizar a portabilidade</h4>
                    <br/>
                    <ul  style={{paddingLeft: "18px"}}>
                        <li style={{listStyle: "disc"}}>DDD não pode ser diferente.</li>
                        <li style={{listStyle: "disc"}}>O CPF/CNPJ devem estar em nome do titular da linha a ser portada.</li>
                        <li style={{listStyle: "disc"}}>Certifique-se que o número a ser portado esteja ativo e que não existem débitos pendentes na operadora antiga.</li>
                        <li style={{listStyle: "disc"}}>Você deve ter ativado seu novo chip com o mesmo CPF/CNPJ cadastrado na operadora antiga.</li>
                        <li style={{listStyle: "disc"}}>Após a solicitação da portabilidade o processo será automático. </li>
                        <li style={{listStyle: "disc"}}>Você pode cancelar a sua solicitação de portabilidade em até 24 horas, após este prazo não será mais possível cancelar o processo. </li>
                        <li style={{listStyle: "disc"}}>O prazo total para efetivar a portabilidade pode levar até 72 horas e você receberá um SMS. </li>
                    </ul>
                    <div className="conten-input">
                        <NumberFormat_  id="newNumber" 
                            name="newNumber" 
                            value={this.state.newNumber}  
                            placeholder="Digite o número novo"
                            onValueChange={(values) => {
                                const {value} = values;
                                this.setState({newNumber: value});
                            }} 
                            format="(##) #####-####" />

                        <NumberFormat_  id="oldNumber" 
                            name="oldNumber" 
                            value={this.state.oldNumber}  
                            placeholder="Digite o número da operadora antiga"
                            onValueChange={(values) => {
                                const {value} = values;
                                this.setState({oldNumber: value});
                            }} 
                            format="(##) #####-####" />

                            <NumberFormat_  id="cpf" 
                            name="cpf" 
                            value={this.state.cpf}  
                            placeholder="Digite o número do CPF"
                            onValueChange={(values) => {
                                const {value} = values;

                                if(value.length === 11 && !this.validCpf(value)){
                                    Swal.fire({
                                        title: 'Erro!',
                                        text: "CPF inválido!",
                                        type: 'error'
                                    })
                                    this.setState({loading: false}); 
                                }

                                this.setState({cpf: value});
                            }} 
                            format="###.###.###-##" />      

                            <select onChange={this.handleChangeSelect.bind(this)} value={this.state.operadora}>
                                <option value="">operadora</option>
                                <option value="DSP_Code">DONOR</option>
                                <option value="0301">DATORA</option>
                                <option value="0302">PORTO CONECTA</option>
                                <option value="0307">AMERICANET MOVIL</option>
                                <option value="0312">CTBC</option>
                                <option value="0314">BRASIL TELECOM CELULAR</option>
                                <option value="0320">VIVO</option>
                                <option value="0321">CLARO</option>
                                <option value="0331">OI</option>
                                <option value="0341">TIM</option>
                                <option value="0343">SERCOMTEL</option>
                                <option value="0351">NEXTEL</option>
                                <option value="ALGAR">ALGAR</option>
                                <option value="CORRE">CORREIOS</option>
                                <option value="FUTCE">FUTCEL</option>
                                <option value="GOSPE">GOSPEL</option>
                                <option value="MAGAL">MAGALU</option>
                                <option value="VEEK">VEEK</option>
                            </select>

                            <input type="text" value={this.state.name} placeholder="Digite seu nome" className="name" onChange={this.handleChange.bind(this)}/>
                    </div>
                
                    <div className={`btn-enviar ${opacity1}`}  onClick={this.executeFunction}>ENVIAR</div>
                </div>
            </div>
        )
    }


}

export default Portabilidade;
